import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../../img/logo.png";

function HeaderAuth() {
  return (
    <nav className="w-full fixed z-50 bg-pink-600">
      <div className="flex items-center justify-between mx-4 md:mx-10 py-3">
        {/* Section logo */}
        <Link to="/" className="flex gap-1 items-center">
          <img src={logo} alt="Logo" className="w-10 md:w-12 lg:w-16" />
          <h3 className="text-2xl md:text-3xl lg:text-5xl poppins-bold text-white">
            ECOKAZ
          </h3>
        </Link>
      </div>
    </nav>
  )
}

export default HeaderAuth